module.exports = __webpack_public_path__ + "media/images/talent/voice-thum01-be828d3dfaaabd3262b6968acd159dca.png";